module.exports = __webpack_public_path__ + "img/firefox.cc4664ae.png";